import * as i0 from '@angular/core';
import { Input, Component } from '@angular/core';
const _c0 = ["*"];
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent {
    constructor() {
      this.sourceId = '';
      this.title = '';
      this.backdropId = 'modalBackdrop';
    }
    close() {
      this.showOffCanvas();
      if (!this.keepBackDrop) {
        this.showBackdrop();
      }
    }
    showOffCanvas() {
      const target = document.getElementById(this.sourceId);
      if (!target) {
        return;
      }
      target.classList.remove('show');
    }
    showBackdrop() {
      const backdrop = document.getElementById(this.backdropId);
      if (!backdrop) {
        return;
      }
      backdrop.classList.remove('show');
    }
    show() {
      const target = document.getElementById(this.sourceId);
      if (!target) {
        return;
      }
      target.classList.add('show');
      document.body.appendChild(target);
      const backdrop = document.getElementById(this.backdropId);
      if (!backdrop) {
        return;
      }
      backdrop.classList.add('show');
    }
    static {
      this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalComponent,
        selectors: [["ui-modal"]],
        inputs: {
          sourceId: "sourceId",
          title: "title",
          keepBackDrop: "keepBackDrop"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 9,
        vars: 2,
        consts: [["data-bs-backdrop", "static", "data-bs-keyboard", "false", "tabindex", "-1", "data-testid", "modal-container", "aria-hidden", "true", 1, "modal", "fade", 3, "id"], [1, "modal-dialog", "modal-dialog-centered", "modal-dialog-scrollable"], [1, "modal-content"], [1, "modal-header"], [1, "modal-title"], ["type", "button", "data-bs-dismiss", "modal", "data-testid", "modal-dismiss", "aria-label", "Close", 1, "btn-close", 3, "click"], [1, "modal-body"]],
        template: function ModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h5", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "button", 5);
            i0.ɵɵlistener("click", function ModalComponent_Template_button_click_6_listener() {
              return ctx.close();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵprojection(8);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.sourceId);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.title);
          }
        },
        encapsulation: 2
      });
    }
  }
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ModalComponent };
